import React from 'react';
import { Empty } from 'antd';
import './index.css';

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <h2 className="page-title">数据仪表盘</h2>
      <div style={{ padding: '100px 0', textAlign: 'center' }}>
        <Empty description="暂无数据" />
      </div>
    </div>
  );
};

export default Dashboard;
